import React, { useCallback, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import ConfirmationDialog from '@ts-core/components/ConfirmationDialog/ConfirmationDialog';

export default (ChildComponent) => {
  const ComposedComponent = (props) => {
    const intl = useIntl();
    const [dialogData, setDialogData] = useState({
      open: false,
      message: '',
      title: '',
      action: null,
      item: undefined,
    });

    const handleConfirmAction = useCallback(
      (onAction, item, { id, values }, { titleId, titleValues } = {}) => {
        setDialogData({
          open: true,
          message: intl.formatMessage({ id }, values),
          title: titleId
            ? intl.formatMessage({ id: titleId }, titleValues)
            : '',
          action: onAction,

          item,
        });
      },
      []
    );

    const handleConfirm = useCallback(() => {
      // eslint-disable-next-line no-unused-expressions
      dialogData.action?.(dialogData.item);
      setDialogData((data) => ({ ...data, open: false }));
    }, [dialogData]);

    const handleCancel = useCallback(() => {
      setDialogData((data) => ({ ...data, open: false }));
    }, []);

    return (
      <>
        <ConfirmationDialog
          open={dialogData.open}
          title={dialogData.title}
          message={dialogData.message}
          confirmActionTitle={<FormattedMessage id="button.yes.title" />}
          cancelActionTitle={<FormattedMessage id="button.no.title" />}
          onCancel={handleCancel}
          onConfirm={handleConfirm}
        />
        <ChildComponent {...props} handleConfirmAction={handleConfirmAction} />
      </>
    );
  };
  return ComposedComponent;
};
